<template>
  <div class="molecule-date-picker-period--container">
    <div class="molecule-date-picker-period--container-start">
      <label v-if="titleStart">{{ titleStart }}</label>
      <atom-datepicker
        :datepickerId="datepickerIdStart"
        v-model="datepicker.start"
        :maxDate="maxDate"
        :type="type"
        :placeholder="placeholderStart"
        class="molecule-date-picker-period--start"
      ></atom-datepicker>
    </div>

    <div class="molecule-date-picker-period--container-end">
      <label v-if="titleEnd">{{ titleEnd }}</label>
      <atom-datepicker
        :datepickerId="datepickerIdEnd"
        v-model="datepicker.end"
        :minDate="minDate"
        :maxDate="dateNow"
        :type="type"
        :placeholder="placeholderEnd"
        class="molecule-date-picker-period--end"
      ></atom-datepicker>
    </div>
  </div>
</template>

<script>
import AtomDatepicker from "@/components/atoms/AtomDatepicker.vue"
export default {
  name: "MoleculeDatePickerPeriod",
  components: { AtomDatepicker },
  props: {
    titleStart: {
      type: String,
      required: false,
      default: "",
    },
    titleEnd: {
      type: String,
      required: false,
      default: "",
    },
    type: {
      type: String,
      required: false,
      default: "date",
      // value: ["date", "time", "dateNtime"]
    },
    placeholderStart: {
      type: String,
      require: false,
      default: "",
    },
    placeholderEnd: {
      type: String,
      require: false,
      default: "",
    },
    minDate: {
      type: String,
      required: false,
      default: null,
    },
    maxDate: {
      type: String,
      required: false,
      default: null,
    },
    dateNow: {
      type: String,
      required: false,
      default: null,
    },
    value: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      datepickerIdStart: "molecule-date-picker-period--start",
      datepickerIdEnd: "molecule-date-picker-period--end",
    }
  },
  computed: {
    datepicker: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit("input", value)
      },
    },
  },
}
</script>

<style lang="scss" scoped>
.molecule-date-picker-period--container {
  width: 100%;
}
.molecule-date-picker-period--container-start {
  width: 100%;
  margin-bottom: 10px;
}
.molecule-date-picker-period--container-end {
  width: 100%; 
}
.molecule-date-picker-period--start {
  width: 100%;
}
.molecule-date-picker-period--end {
  width: 100%;
}

@media screen and (min-width: 576px) {
  .molecule-date-picker-period--container {
    display: flex;
  }
  .molecule-date-picker-period--container-start {
    width: 50%;
    margin-bottom: 0;
    margin-right: 5px;
  }
  .molecule-date-picker-period--container-end {
    width: 50%;
    margin-left: 5px;
  }
  .molecule-date-picker-period--end {
    margin-top: 0;
  }
}
</style>
